export default {
    data() {
        return {
            requireDateChangeHistories: []
        }
    },
    methods: {
        handleLinkClick(key, row, event) {
            const poNumber = row.purchasingDocNumber;
            const poItemNumber = row.purchasingDocItemNumber;
            if (poItemNumber && poNumber) {
                let queryForm = {};
                queryForm.sourceFilter = 0
                queryForm.poNumberFilter = poNumber;
                queryForm.poItemNumberFilter = poItemNumber;
                this.$_emApiMixin_post(this.$_emApiMixin_moduleBaseApi("sithMesStoolRequireDateChangeHistory") + "/sithMesStoolRequireDateChangeHistory/findByFilter", queryForm)
                    .then((response) => {
                        this.requireDateChangeHistories = response.data.list
                    })
                let updateForm = {};
                updateForm.targetIds = [row.id]
                updateForm.source = 0
                this.$_emApiMixin_post(this.$_emApiMixin_moduleBaseApi("sithMesStoolRequireDateChangeHistory") + "/sithMesStoolRequireDateChangeHistory/removeUnReadChangeHistoryIds", updateForm)
                    .then(() => {
                        event.target.parentElement.parentElement.classList.remove("bg-danger")
                        this.$refs.requireDateChangeHistory.showModal()
                    })
            }
        },
        readChangeHistories() {
            let updateForm = {};
            updateForm.targetIds = this.$_emCustomVuexMixin_checkItems
            updateForm.source = 0
            this.$_emApiMixin_post(this.$_emApiMixin_moduleBaseApi("sithMesStoolRequireDateChangeHistory") + "/sithMesStoolRequireDateChangeHistory/removeUnReadChangeHistoryIds", updateForm)
            this.$refs["emListFilter"].doQuery();
        }
    }
}